module.exports = __webpack_public_path__ + "static/media/info.af3a7a79.svg";